
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ReportHistoryEntry, AppSettings } from '../../types';
import { fitLogoBox, imgFmt } from './letterhead';

export const generateHistoryListPDF = (history: ReportHistoryEntry[], timeRangeLabel: string, settings?: AppSettings): jsPDF => {
    const doc = new jsPDF({ compress: true });
    const margin = 20;
    let currentY = 20;

    if (settings?.companyLogo) {
        try {
            // fitLogoBox + Formaterkennung wie im Briefkopf: Hoehe allein
            // laesst breite Logos ueber den Blattrand laufen, hart 'JPEG'
            // verstuemmelt PNG-Logos.
            const logoHeight = 15;
            const box = fitLogoBox(doc.getImageProperties(settings.companyLogo), 60, logoHeight);
            if (box) {
                doc.addImage(settings.companyLogo, imgFmt(settings.companyLogo), doc.internal.pageSize.width - margin - box.width, 15 + (logoHeight - box.height), box.width, box.height);
            }
        } catch {}
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(30, 41, 59);
    doc.text("Begehungshistorie", margin, currentY + 10);
    
    currentY += 20;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    doc.text(`Zeitraum: ${timeRangeLabel}`, margin, currentY);
    doc.text(`Erstellt am: ${new Date().toLocaleDateString('de-DE')}`, margin + 80, currentY);
    
    currentY += 10;

    const rows = history.map(entry => {
        const dateStr = new Date(entry.date).toLocaleDateString('de-DE');
        // Die Archivliste traegt seit 30.09.2026 nur Kopf und Metadaten, nicht
        // den Maengelbestand (fetchReportHistoryList — der volle Schnappschuss
        // wird erst beim PDF geladen). Ohne `items` ist die Zahl unbekannt, nicht
        // null: „–“ statt eines erfundenen „0 (O:0/E:0)“.
        const items = entry.reportData?.items;
        const eintraege = Array.isArray(items)
            ? `${items.length} (O:${items.filter(i => i.status === 'open').length}/E:${items.filter(i => i.status === 'closed').length})`
            : '–';

        return [
            entry.inspectionNumber.toString(),
            dateStr,
            entry.projectName,
            entry.conductedByName,
            eintraege
        ];
    });

    autoTable(doc, {
        startY: currentY,
        head: [['Nr.', 'Datum', 'Projekt', 'Durchgeführt von', 'Einträge (Offen/Erledigt)']],
        body: rows,
        theme: 'striped',
        headStyles: { fillColor: [51, 65, 85] },
        styles: { fontSize: 9 },
        columnStyles: {
            0: { cellWidth: 15, fontStyle: 'bold' },
            1: { cellWidth: 25 },
            4: { cellWidth: 40, halign: 'center' }
        }
    });

    return doc;
};
